import React from 'react';

// Context
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Components
import Workspace from './components/Workspace';

// Global scripts
import '@salesforce/canvas-js-sdk';

// Global styles
import 'semantic-ui-css/semantic.min.css';
import './App.css';

/**
 * WebUI application root
 *
 * This component creates the Workspace and wraps it with the context
 * producers required for it to operate.
 */
const App = (props) => (
  <Router>
    <AuthProvider placeholder={<Workspace.Placeholder />}>
      <Workspace />
    </AuthProvider>
  </Router>
);

export default App;
